module.exports = __webpack_public_path__ + "img/special-handling.6b795fde.svg";